import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FwIconModule, FwLayoutsModule, FwPopoverModule } from '@flywheel-io/vision';

import { LdapSync } from '../../shared/models/ldap.model';

@Component({
  selector: 'app-ldap-indicator',
  standalone: true,
  imports: [MatIconModule, FwPopoverModule, FwIconModule, CdkOverlayOrigin, FwLayoutsModule, CommonModule],
  templateUrl: './ldap-indicator.component.html',
  styleUrl: './ldap-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LdapIndicatorComponent {
  ldapStatus = input<LdapSync>();
}
